import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import MovieSection from "@/pages/home/components/MovieSection";
import { getFeaturedMovies, getHotMovies, getLatestMovies } from "@/utils/movie";

const stats = [
  { icon: "ri-film-line", value: "24+", label: "精选影视资源" },
  { icon: "ri-live-line", value: "3", label: "内容分类" },
  { icon: "ri-hd-line", value: "高清", label: "画质体验" },
  { icon: "ri-money-cny-circle-line", value: "免费", label: "在线观看" },
];

export default function Home() {
  const featured = getFeaturedMovies();
  const latest = getLatestMovies();
  const hot = getHotMovies(10);

  return (
    <div className="pb-4">
      <HeroCarousel items={featured} />

      <div className="mt-10 md:mt-14 relative z-20">
        <CategoryEntries />
      </div>

      <div className="mt-14 md:mt-20">
        <MovieSection
          eyebrow="Just In"
          title="最新上线"
          description="午夜剧场不断更新，第一时间发现刚刚上线的影视作品。"
          movies={latest}
          paginate
          initialCount={10}
          step={10}
          action={
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
      </div>

      <div className="mt-14 md:mt-20">
        <MovieSection
          eyebrow="Trending"
          title="热门推荐"
          description="根据播放热度排序，看看这个午夜大家都在看什么。"
          movies={hot}
          action={
            <Link
              to="/category"
              className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              更多热门
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />
      </div>

      <section className="mt-16 md:mt-24 mx-auto max-w-page px-4 md:px-8">
        <div className="relative rounded-lg overflow-hidden bg-accent-900 border border-accent-800/60">
          <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-primary-500/15 blur-3xl"></div>
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 p-6 md:p-12">
            <div className="lg:col-span-7">
              <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.22em] text-primary-300 uppercase">
                <span className="w-6 h-px bg-primary-500/70"></span>
                About Midnight
              </span>
              <h2 className="mt-3 font-heading font-extrabold text-2xl md:text-4xl text-foreground-950">
                属于午夜的免费高清影视空间
              </h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
                午夜免费视频专注于为喜欢深夜观影的用户提供免费高清的影视内容。我们聚合电影、电视剧、综艺等多种午夜影视资源，
                通过清晰的分类、灵活的筛选与精准的搜索，帮助你快速找到想看的那一部。无需注册复杂流程，打开即可浏览、发现并沉浸在一个人的午夜剧场。
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Link
                  to="/category"
                  className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-compass-3-line text-lg"></i>
                  开始探索影视
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-background-100/80 border border-background-300/70 text-foreground-950 text-sm font-medium hover:border-primary-500/60 transition-colors whitespace-nowrap"
                >
                  了解我们
                </Link>
              </div>
            </div>
            <div className="lg:col-span-5 grid grid-cols-2 gap-3 md:gap-4">
              {stats.map((item) => (
                <div key={item.label} className="rounded-lg bg-background-100/70 border border-background-300/60 p-4 md:p-5">
                  <span className="w-10 h-10 rounded-md bg-primary-500/15 text-primary-300 flex items-center justify-center">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <p className="mt-3 font-heading font-extrabold text-xl md:text-2xl text-foreground-950">{item.value}</p>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}